import AffiliationPage  from 'ml-capability-quoteandbind-common-react';
import SummaryPage from 'gw-capability-quoteandbind-common-react';
import MLStickyContinueSectionComponent from './components/MLStickyContinueSectionComponent/MLStickyContinueSectionComponent';
import GatewayYourInfoPage from './pages/GatewayYourInfo/GatewayYourInfoPage';
import GatewayQuotePage from './pages/GatewayQuote/GatewayQuotePage';
import GatewayConfirmationPage from './pages/GatewayConfirmation/GatewayConfirmationPage';
import GatewayDisclosurePage from './pages/GatewayDisclosurePage/GatewayDisclosurePage';
import BindingScriptsPage from './pages/BindingScripts/BindingScriptsPage';
import AgentSignatureOptionsPage from './pages/AgentSignatureOptions/AgentSignatureOptionsPage';
import MLAccountDetails from './pages/MLAccountDetails/MLAccountDetails';
import MLPolicyDetails from './pages/MLPolicyDetails/MLPolicyDetails';
import MLGatewayCompRaterWizard from './pages/MLGatewayCompRaterWizard/CompRaterWizard';

const customerGatewayQuoteAndBindCommonComponentMap = {
    AffiliationPage: { component: 'AffiliationPage' },
    MLStickyContinueSectionComponent: { component: 'MLStickyContinueSectionComponent' },
    GatewayYourInfoPage: { component: 'GatewayYourInfoPage' },
    GatewayQuotePage: { component: 'GatewayQuotePage' },
    GatewayConfirmationPage : {component: 'GatewayConfirmationPage'},
    GatewayDisclosurePage: { component: 'GatewayDisclosurePage' },
    BindingScriptsPage: { component: 'BindingScriptsPage' },
    AgentSignatureOptionsPage: { component: 'AgentSignatureOptionsPage' },
    MLAccountDetails : { component: 'MLAccountDetails'},
    MLPolicyDetails : { component: 'MLPolicyDetails'},
    SummaryPage : { component: 'SummaryPage'},
    MLGatewayCompRaterWizard: { component: 'MLGatewayCompRaterWizard'}
    
};

const customerGatewayQuoteAndBindCommonComponents = {
    MLStickyContinueSectionComponent,
    GatewayYourInfoPage,
    GatewayQuotePage,
    GatewayConfirmationPage,
    GatewayDisclosurePage,
    BindingScriptsPage,
    AgentSignatureOptionsPage,
    MLAccountDetails,
    MLPolicyDetails,
    MLGatewayCompRaterWizard
};

export {
    customerGatewayQuoteAndBindCommonComponentMap,
    customerGatewayQuoteAndBindCommonComponents
};

export { default as MLNewQuoteAccountSearchComponent } from './components/MLNewQuoteAccountSearchComponent/MLNewQuoteAccountSearchComponent';
export { default as MLNewQuoteDialogModal } from './components/MLNewQuoteDialogModal/MLNewQuoteDialogModal';
export { default as MLNewQuoteDialogModalMessages } from './components/MLNewQuoteDialogModal/MLNewQuoteDialogModal.messages';
export { default as MLAccountDetails } from './pages/MLAccountDetails/MLAccountDetails';
export { default as MLPolicyDetails } from './pages/MLPolicyDetails/MLPolicyDetails';
export { default as MLAgentQuoteStickyComponent } from './components/MLAgentQuoteStickyComponent/MLAgentQuoteStickyComponent';
export {default as MLStickyContinueSectionComponent} from './components/MLStickyContinueSectionComponent/MLStickyContinueSectionComponent';
export { default as MLQuotePageProposalComponent } from './components/MLQuotePageProposalComponent/MLQuotePageProposalComponent';
export { default as MLUWIssuesPanelComponent } from './components/MLUWIssuesPanelComponent/MLUWIssuesPanelComponent';
export { default as MLMinimumUnderlyingLimitModal } from './components/MLMinimumUnderlyingLimitModal/MLMinimumUnderlyingLimitModal';
export { default as MLBundleCart } from './pages/BundleCart/MLBundleCart';
export { default as MLBundleConfirmation } from './pages/BundleConfirmation/MLBundleConfirmation';
export { default as MLGatewayHVQLandingPage } from './pages/MLGatewayHVQLandingPage/MLGatewayHVQLandingPage';
export { default as MLGatewayCompRaterWizard } from './pages/MLGatewayCompRaterWizard/CompRaterWizard';
export { MLLandingPageProvider, useMLLandingPageContext } from './components/MLLandingPageContext/MLLandingPageContext';
